import { HTMLProps, ReactElement, ReactNode } from "react";
import { Tooltip, TooltipProps } from "@mui/material";

export type FormControlTooltipProps<WrapDisabledChild extends boolean | undefined = undefined> = {
	children: ReactElement;
	tooltip?: ReactNode;
	disabled?: boolean;
	disabledTooltip?: ReactNode;
	wrapDisabledChild?: WrapDisabledChild;
	slotProps?: {
		tooltip?: Omit<TooltipProps, "title" | "children">;
		tooltipWrapper?: WrapDisabledChild extends false ? undefined : HTMLProps<HTMLDivElement>;
	};
};

export default function FormControlTooltip<WrapDisabledChild extends boolean | undefined = undefined>({
	tooltip,
	disabled,
	disabledTooltip,
	wrapDisabledChild = true,
	slotProps,
	children,
}: FormControlTooltipProps<WrapDisabledChild>) {
	const resolvedDisabled = disabled ?? children.props.disabled ?? false;
	const wrappedChild =
		resolvedDisabled && wrapDisabledChild ? <div {...slotProps?.tooltipWrapper}>{children}</div> : children;

	if (tooltip || (resolvedDisabled && disabledTooltip)) {
		return (
			<Tooltip {...slotProps?.tooltip} title={resolvedDisabled && disabledTooltip ? disabledTooltip : tooltip}>
				{wrappedChild}
			</Tooltip>
		);
	} else {
		return children;
	}
}
